// extracted by mini-css-extract-plugin
module.exports = {"separator":"FullWidth_separator__CZu2J","fullWidthBustOut":"FullWidth_fullWidthBustOut__a58QL","fullWidth":"FullWidth_fullWidth__dlhPG"};